import { Colors as LibraryColors } from '@mercator-gcp/grout';

export const Colors = {
  ...LibraryColors,
  // --- DEPRECATED ---
  alert: '#FF6813',
  'alert-hover': '#E05202',
  'light-green': '#E6F2EB',
  'light-green-hover': '#DAE9DD',
  'army-100': '#F4F5F5',
  'army-green': '#027a3b',
  'army-green-hover': '#026C33',
  'army-green-dark': '#2c402e',
  'army-green-darkest': '#162018',
  'army-dark': '#1F2B22',
  'dark-green': '#8D988E',
  'dark-green-200': '#EAECEA',
  'tan-light': '#fbfaf6',
  'tan-50': 'rgba(247, 245, 237, 0.5)',
  'tan-darker': '#e0ded3',
  'tan-darkest': '#8a8983',
  'tan-100': '#FBFAF6',
  'tan-200': '#F1F1EC',
  'tan-300': '#E5E5DC',
  grey: '#8b8f8b',
  green: '#027a3b',
  lightGreen: '#DAE9DC',
  'grey-light': '#cbcfcb',
  'grey-lighter': '#f1f1ee',
  'grey-dark': '#5c5b57',
  disabled: '#CCD1CC',
  red: '#f75949',
  white: '#ffffff',
  black: '#1F2B22',
  'black-alpha': 'rgba(0, 0, 0, 0.05)',
  'black-original': '#000000',
  beige: '#E5E5E5',
  'border-color': '#16201811',
  disabledBackground: '#2C402E',
  disabledText: '#5B6D5D',
  text: {
    quiet: '#76746F',
  },
  loading: {
    color: '#027A3B',
  },
  tangerine: {
    900: '#E05202',
    700: '#FF6813',
    500: '#FBECE0',
    300: 'rgba(255, 104, 19, 0.5)',
    200: 'rgba(255, 104, 19, 0.2)',
    100: 'rgba(255, 104, 19, 0.1)',
  },
};
